import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Icon, Message } from 'semantic-ui-react';
import {
  errorDetails, errorHasLinks, errorMessage, errorTitle,
} from '@/utils/errors';
import FormattedHTMLMessage from '../FormattedHTMLMessage';

const listItems = (items) => (
  items.map((item) => (<Message.Item key={`aridhia-error-message-detail ${item}`} content={item} />))
);

const ErrorMessage = ({
  className,
  error,
  icon = 'warning circle',
  onDismiss,
}) => {
  const intl = useIntl();
  const title = errorTitle(error, intl);
  const items = errorDetails(error, intl);

  return (
    <Message
      className={clsx('aridhia-error-message', className)}
      error={!error.warning}
      warning={error.warning}
      size="small"
      icon
      onDismiss={onDismiss}
    >
      <Icon name={icon} />
      <Message.Content>
        {title && (<Message.Header content={title} />)}
        {errorHasLinks(error) && (
          <FormattedHTMLMessage id={error.message} values={error.translation.messageArgs || {}} />
        )}
        {!errorHasLinks(error) && (<>{errorMessage(error, intl)}</>)}
        {items.length > 0 && (
        <Message.List>
          {listItems(items)}
        </Message.List>
        )}
      </Message.Content>
    </Message>
  );
};

export default ErrorMessage;
